import React from 'react'
import { TextField } from '@material-ui/core'

interface DateTimeInputProps {
  value: Date | null | undefined
  onChange: (date: Date | null) => void
  label: string
  required?: boolean
  error?: boolean
  helperText?: string
  disabled?: boolean
  inputVariant?: 'outlined' | 'filled' | 'standard'
  fullWidth?: boolean
}

export const DateTimeInput: React.FC<DateTimeInputProps> = ({
  value,
  onChange,
  label,
  required = false,
  error = false,
  helperText,
  disabled = false,
  inputVariant = 'outlined',
  fullWidth = false
}) => {
  // Converte Date para string no formato datetime-local
  const dateToString = (date: Date | null | undefined): string => {
    if (!date) return ''

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')

    return `${year}-${month}-${day}T${hours}:${minutes}`
  }

  // Converte string datetime-local para Date
  const stringToDate = (str: string): Date | null => {
    if (!str) return null
    return new Date(str)
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newDate = stringToDate(event.target.value)
    onChange(newDate)
  }

  return (
    <TextField
      type="datetime-local"
      value={dateToString(value)}
      onChange={handleChange}
      label={label}
      required={required}
      error={error}
      helperText={helperText}
      disabled={disabled}
      variant={inputVariant}
      fullWidth={fullWidth}
      InputLabelProps={{
        shrink: true
      }}
    />
  )
}
